(function () {
    "use strict";

    angular.module("app.cart").factory("CartService", CartService);

    CartService.$inject = ["$http", "$q"];

    function CartService($http, $q) {
        var service = {
            getCart: getCart,
            updateCart: updateCart,
            InsertWithParams: InsertWithParams,
            Insert: Insert,
            Increment: Increment,
            Decrement: Decrement,
            Update: Update,
            Delete: Delete,
            IsInCart: IsInCart,
            ApplyCoupon: ApplyCoupon,
            RemoveCoupon: RemoveCoupon,
            getRelatedProducts: getRelatedProducts,
        };
        return service;

        function getCart(params) {
            var deferred = $q.defer();
            var url = "/Cart";
            if (params && params.Id) {
                url += "/Detail/" + params.Id;
            }
            if (params && params.CartType) {
                url += "?CartType=" + params.CartType;
            }
            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function IsInCart(params) {
            var deferred = $q.defer();

            var url = "/Cart/IsInCart";
            $http
                .get(url, {
                    params: params,
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }


        function getRelatedProducts(filterModel) {
            var deferred = $q.defer();
            var url = "/api/Product/GetRelatedProductList";
            $http
                .get(url, {
                    params: filterModel,
                })
                .then(getRelatedProductListComplete)
                .catch(getRelatedProductListFailed);

            function getRelatedProductListComplete(response) {
                deferred.resolve(response);
            }

            function getRelatedProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function updateCart(cart) {
            var deferred = $q.defer();

            $http
                .put("/Cart/" + cart.Id, cart)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function InsertWithParams(params) {
            var cartProduct = {
                ProductId: params.productID,
                Quantity: params.quantity,
                DynamicQuantity: params.dynamicQuantity,
                CartType: params.CartType,
                CartId: params.cartId,
                BaseGroupProductName: params.BaseGroupProductName,
                BaseGroupProductLink: params.BaseGroupProductLink,
                BaseGroupProductImage: params.BaseGroupProductImage,
                WarehouseId: params.WarehouseId,
            };
            if (typeof params.variantValues !== "string") {
                cartProduct.VariantValues = JSON.stringify(
                    params.variantValues
                );
            } else {
                cartProduct.VariantValues = params.variantValues;
            }
            return Insert(cartProduct);
        }

        function Insert(cartProduct) {
            var deferred = $q.defer();
            if (cartProduct.dynamicQuantity) {
                $http
                    .post(
                        "/Cart/Product/" +
                        cartProduct.ProductId +
                        "/" +
                        cartProduct.Quantity +
                        "/" +
                        cartProduct.DynamicQuantity,
                        cartProduct
                    )
                    .then(complete)
                    .catch(failed);
            } else {
                $http
                    .post(
                        "/Cart/Product/" +
                        cartProduct.ProductId +
                        "/" +
                        cartProduct.Quantity,
                        cartProduct
                    )
                    .then(complete)
                    .catch(failed);
            }

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Increment(cartProduct) {
            var deferred = $q.defer();
            var quantity =
                cartProduct.Quantity + cartProduct.Product.DefaultIncrement;
            if (quantity > cartProduct.Product.maxCartQuantity) {
                quantity = cartProduct.Product.maxCartQuantity;
            }
            $http
                .put(
                    "/Cart/Product/" +
                    cartProduct.ProductId +
                    "/" +
                    (cartProduct.Quantity +
                        cartProduct.Product.DefaultIncrement),
                    {
                        Id: cartProduct.Id,
                        ProductId: cartProduct.ProductId,
                        Quantity: quantity,
                        DynamicQuantity: cartProduct.DynamicQuantity,
                        WareHouseId: cartProduct.WareHouseId,
                    }
                )
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Decrement(cartProduct) {
            var deferred = $q.defer();
            var quantity =
                cartProduct.Quantity - cartProduct.Product.DefaultIncrement;
            if (quantity < cartProduct.Product.minCartQuantity) {
                quantity = cartProduct.Product.minCartQuantity;
            }
            $http
                .put(
                    "/Cart/Product/" + cartProduct.ProductId + "/" + quantity,
                    {
                        Id: cartProduct.Id,
                        ProductId: cartProduct.ProductId,
                        Quantity: quantity,
                        DynamicQuantity: cartProduct.DynamicQuantity,
                        WareHouseId: cartProduct.WareHouseId,
                    }
                )
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Update(cartProduct) {
            var deferred = $q.defer();

            $http
                .put(
                    "/Cart/Product/" +
                    cartProduct.ProductId +
                    "/" +
                    cartProduct.Quantity,
                    {
                        Id: cartProduct.Id,
                        ProductId: cartProduct.ProductId,
                        Quantity: cartProduct.Quantity,
                    }
                )
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Delete(cartProduct) {
            var deferred = $q.defer();

            $http
                .delete("/Cart/Product/" + cartProduct.Id)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function ApplyCoupon(coupon) {
            var deferred = $q.defer();

            $http
                .get("/Cart/ApplyCouponCode", {
                    params: {
                        CouponCode: coupon,
                    },
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
        function RemoveCoupon() {
            var deferred = $q.defer();

            $http.get("/Cart/RemoveCouponCode").then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
